import i18n from '@/plugins/i18n'

export const reports=[
    {
        value: '1',
        text: i18n.t('attendance_report'),
        permission: 'eslreport_attendance'
    },
    {
        value: '2',
        text: i18n.t('number_of_students_registered_in_classes'),
        permission: 'eslreport_numberofstudents'
    },
    {
        value: '3',
        text: i18n.t('conditional_pass'),
        permission: 'eslreport_conditionalpass'
    },
    {
        value: '4',
        text: i18n.t('pass_fail_report'),
        permission: 'eslreport_sessionpassfailbyyear'
    },
    {
        value: '5',
        text: i18n.t('pass_fail_data_by_session'),
        permission: 'eslreport_passfailbysession'
    },
    {
        value: '6',
        text: i18n.t('gender_report'),
        permission: 'eslreport_genderdistributionbyyear'
    },
    {
        value: '7',
        text: i18n.t('student_time_of'),
        permission: 'eslreport_studenttimeoff'
    },
    {
        value: '8',
        text: i18n.t('Achievement Scale by Module'),
        permission: 'eslreport_achievementscale'
    },
    {
        value: '9',
        text: i18n.t('pass_fail_rate_data_by_level'),
        permission: 'eslreport_passfailratebylevel'
    },
    {
        value: '10',
        text: i18n.t('pass_fail_data_by_assessment'),
        permission: 'eslreport_passfaildatabyassessment'
    },
    {
        value: '11',
        text: i18n.t('country_report'),
        permission: 'eslreport_countryreport'
    },
    // {
    //     value: '12',
    //     text: i18n.t('visa_type_report'),
    //     permission: 'eslreport_visatypereportforyear'
    // },
    {
        value: '13',
        text: i18n.t('transfer_out_report'),
        permission: 'eslreport_transferoutreport'
    },
    {
        value: '14',
        text: i18n.t('received_payments_report'),
        permission: 'eslreport_receivedpayment'
    },
    {
        value: '15',
        text: i18n.t('payment_detail_report'),
        permission: 'eslreport_paymentdetailreport'
    },
    {
        value: '16',
        text: i18n.t('mentora_sevis_registration_report'),
        permission: 'studentreport_mentorasevisregistrationreport'
    },
    {
        value: '17',
        text: i18n.t('roster_report'),
        permission: 'eslreport_rosterreport'
    },
    {
        value: '18',
        text: i18n.t('preview_roster_report'),
        permission: 'eslreport_previewrosterreport'
    },
    {
        value: '19',
        text: i18n.t('media_opt_out_report'),
        permission: 'eslreport_mediaoptout'
    },
    {
        value: '20',
        text: i18n.t('mentora_current_students_not_registered_report'),
        permission: 'eslreport_currentstudentsnotregistered'
    },
    {
        value: '21',
        text: i18n.t('termination_completion_report'),
        permission: 'eslreport_terminationcompletion'
    },
    {
        value: '22',
        text: i18n.t('mentora_student_course_registration_report'),
        permission: 'eslreport_studentcourseregistration'
    },
    {
        value: '23',
        text: i18n.t('mentora_missing_enrollment_agreements_report'),
        permission: 'eslreport_missingenrollmentagreement'
    },
    {
        value: '24',
        text: i18n.t('level_600class_assignment_report'),
        permission: 'eslreport_level600classassignment'
    },
    {
        value: '25',
        text: i18n.t('level_100and500_class_assignment_report'),
        permission: 'eslreport_level100and500classassignment'
    },
    {
        value: '26',
        text: i18n.t('collection_report'),
        permission: 'eslreport_collection'
    },
    {
        value: '27',
        text: i18n.t('bank_reconciliation'),
        permission: 'eslreport_bankreconciliation'
    },
    {
        value: '28',
        text: i18n.t('mentora_attendance_entry_tracking'),
        permission: 'eslreport_attendanceentrytracking'
    },
    {
        value: '29',
        text: i18n.t('mentora_agency_report'),
        permission: 'eslreport_agency'
    },

    {
        value: '30',
        text: i18n.t('history_of_module'),
        permission: 'eslreport_historyofmodule'
    },

    {
        value: '31',
        text: i18n.t('module_student_list'),
        permission: 'eslreport_modulestudentlist'
    },
    {
        value: '32',
        text: i18n.t('module_enrollment_comparison'),
        permission: 'eslreport_moduleenrollmentcomparison'
    },


]

